import React, { useRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Box,
  Typography,
  Stack,
  Divider,

} from '@mui/material';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import logo from '../../assets/SVG/Clinic Logo.png';
import { generatePDF } from '../../utils/reportUtils';
import { useTranslation } from 'react-i18next';
import { ClinicHeader } from '../Reports/ClinicHeader';
import PrintStyles from '../Reports/Registration/PrintStyles';
import PatientDetailsHeader from '../Reports/PatientDetailsHeader';

interface ReusableReportComponentProps {
  open: boolean;
  onClose: () => void;
  reportTitle: string;
  children: React.ReactNode;
  clinicName?: string;
  clinicAddress?: string;
  email?: string;
  mobileNo?: string;
  logoUrl?: string;
  showPatientDetails?: boolean;
}

const ReusableReportComponent: React.FC<ReusableReportComponentProps> = ({
  open,
  onClose,
  reportTitle,
  children,
  showPatientDetails = true,
}) => {
  const reportRef = useRef<HTMLDivElement>(null);
  const { t: tGeneral } = useTranslation('general');
  const handleDownloadPDF = () => {
    if (reportRef.current) {
      generatePDF(reportRef.current, reportTitle.replace(/\s+/g, '_'));
    }
  };
  const handlePrint = () => {
    window.print();
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" scroll="paper">
      <DialogTitle sx={{ p: 3, pb: 0 }}>
        <PrintStyles/>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <Typography variant="h5" fontWeight={500}>
            {reportTitle}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Button
              variant="contained"
              onClick={handleDownloadPDF}
              sx={{
                backgroundColor: '#404040',
                color: 'white',
                '&:hover': { backgroundColor: '#505050' },
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                textTransform: 'capitalize',
              }}
              startIcon={<DownloadIcon />}
            >
              {tGeneral('Download_Report')}
            </Button>
            <Button variant="outlined" onClick={handlePrint} sx={{ ml: 2 }}>
              {tGeneral('Print_Report')}
            </Button>
            <IconButton onClick={onClose} color="error" aria-label="Close Dialog">
              <HighlightOffIcon />
            </IconButton>
          </Stack>
        </Stack>
        <Divider sx={{ mt: 3 }} />
      </DialogTitle>
      <DialogContent dividers sx={{ p: 1, padding: 'inherit' }}>
        <div ref={reportRef} id="printable-report" >
          <Box>
            <ClinicHeader/>
          </Box>
          {/* Patient Details Section */}
          {showPatientDetails && (
            <Box sx={{ px: 4, py: 1.5, color: '#333', fontFamily: 'Arial, sans-serif' }}>
              <PatientDetailsHeader />
            </Box>
          )}
          <Box mt={2}>{children}</Box>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReusableReportComponent;

